const deepCopy = (obj) => {
  const result = obj instanceof Array ? [] : {}
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      result[key] = deepCopy(obj[key])
    } else {
      result[key] = obj[key]
    }
  })
  return result
}
export default deepCopy